export const GET_CONCEPTS = 'GET_CONCEPTS'
export const GET_CONCEPTS_SUCCESS = 'GET_CONCEPTS_SUCCESS'
export const GET_CONCEPTS_FAILED = 'GET_CONCEPTS_FAILED'

export const SAVE_CONCEPTS = 'SAVE_CONCEPTS'
export const SAVE_CONCEPTS_SUCCESS = 'SAVE_CONCEPTS_SUCCESS'
export const SAVE_CONCEPTS_FAILED = 'SAVE_CONCEPTS_FAILED'
